export default __webpack_public_path__ + "static/dylan-1c5b6188665fd22cc3f348b22bfeec69.jpg";